const appendChildToHead = (element) =>
  document.getElementsByTagName('head')[0].appendChild(element);
const appendChildToBody = (element) =>
  document.getElementsByTagName('body')[0].appendChild(element);

/**
 * Iterate an HTMLCollection (ex: result from Element.children).
 * @param {HTMLCollection|NodeList} htmlCollection live collection of elements
 * @param {Function} callback function to execute in every element
 */
const forEachElement = (htmlCollection, callback) => {
  Array.from(htmlCollection).forEach(callback);
};

/**
 * Create a form and send it to
 * @param {string} action url to form call
 * @param {Object} data object to generate inputs with key as name and value
 */
const createPostFormAndSubmit = (action, data) => {
  const form = document.createElement('form');
  form.setAttribute('method', 'POST');
  form.setAttribute('action', action);
  Object.entries(data).forEach(([name, value]) => {
    const ele = document.createElement('input');
    ele.setAttribute('name', name);
    ele.setAttribute('value', value);
    form.appendChild(ele);
  });
  appendChildToBody(form);
  form.submit();
};

/**
 * Create new <script> for the given url
 * @param {string} cssfile url to an external stylesheet
 * @returns {Element} <link> element
 */
const createElementForExternalCss = (cssfile) => {
  const file = document.createElement('link');
  file.setAttribute('rel', 'stylesheet');
  file.setAttribute('type', 'text/css');
  file.setAttribute('href', cssfile);
  return file;
};

/**
 * Create new <script> for the given src
 * @param {string} jsfile url to an external JS
 * @returns {Element} <script> element
 */
const createElementForExternalScript = (jsfile) => {
  const file = document.createElement('script');
  file.setAttribute('type', 'text/javascript');
  file.setAttribute('src', jsfile);
  return file;
};

/**
 * Returns true if the file is already attached
 * @param {string} urlToFile url to an static file
 * @param {string} filetype 'js' or 'css'
 * @returns {boolean}
 */
function handleFileExistence(urlToFile, filetype) {
  if (filetype === 'js') {
    // For js files, remove the existing one to ensure correct behaviour
    const existingScript = document.querySelector(`script[src="${urlToFile}"]`);
    if (existingScript) {
      existingScript.remove();
    }
  } else if (filetype === 'css') {
    return !!document.querySelector(
      `link[rel="stylesheet"][href="${urlToFile}"]`
    );
  }
  return false;
}

/**
 * Append to <HEAD> element a new script or stylesheet
 * @param {string} urlToFile url to an static file
 * @param {string} filetype 'js' or 'css'
 * @returns {void}
 */
const appendNewExternalJavascriptOrCss = (urlToFile, filetype) => {
  let file = null;
  if (!handleFileExistence(urlToFile, filetype)) {
    if (filetype === 'js') {
      file = createElementForExternalScript(urlToFile);
    } else if (filetype === 'css') {
      file = createElementForExternalCss(urlToFile);
    }
  }
  if (file !== null) {
    appendChildToHead(file);
  }
};

const isTag = (element, tagName) => element.tagName.toLowerCase() === tagName;

const loadAssetsFromObject = (includeAssets = {}) => {
  Object.entries(includeAssets).forEach(([key, assetsList]) => {
    assetsList.forEach((asset) => {
      appendNewExternalJavascriptOrCss(asset, key);
    });
  });
};

/**
 * Create or replace the content of a meta tag
 * @param {string} metaName name of the meta
 * @param {string} newContent  content of the meta tag
 */
const setMeta = (metaName, newContent) => {
  let meta = document.querySelector(`meta[name=${metaName}]`);
  if (!meta) {
    const newMeta = document.createElement('meta');
    newMeta.setAttribute('name', metaName);
    meta = appendChildToHead(newMeta);
  }
  meta.setAttribute('content', newContent);
};

/**
 * Hide dom elements passing selector
 * @param {string} selector
 * @param {HTMLElement} [parentNode]
 */
function hideElementsBySelector(selector, parentNode = document) {
  const elementsToHide = parentNode.querySelectorAll(selector);
  elementsToHide?.forEach((element) => {
    element.classList.add('d-none');
  });
}

/**
 * Show dom elements passing selector
 * @param {string} selector
 * @param {HTMLElement} [parentNode]
 */
function showElementsBySelector(selector, parentNode = document) {
  const elementsToHide = parentNode.querySelectorAll(selector);
  elementsToHide?.forEach((element) => {
    element.classList.remove('d-none');
  });
}

/**
 * Hide dom elements passing selector
 * @param {string} selector
 * @param {HTMLElement} [parentNode]
 */
function addVisibilityHiddenBySelector(selector, parentNode = document) {
  const elementsToHide = parentNode.querySelectorAll(selector);
  elementsToHide?.forEach((element) => {
    element.classList.add('visibility-hidden');
  });
}

/**
 * Show dom elements passing selector
 * @param {string} selector
 * @param {HTMLElement} [parentNode]
 */
function removeVisibilityHiddenBySelector(selector, parentNode = document) {
  const elementsToHide = parentNode.querySelectorAll(selector);
  elementsToHide?.forEach((element) => {
    element.classList.remove('visibility-hidden');
  });
}

/**
 * Show/hide dom elements passing selector
 * @param {string} selector
 * @param {HTMLElement} [parentNode]
 */
function toggleElementsBySelector(selector, parentNode = document) {
  const elementsToHide = parentNode.querySelectorAll(selector);
  elementsToHide?.forEach((element) => {
    element.classList.toggle('d-none');
  });
}

/**
 * Checks if input, select or textarea is empty
 * @param  {Object} field - input, select or textarea Javascript DOM element
 * @returns true if empty, false otherwise
 */
function isFieldEmpty(field) {
  if ($(field).is('input[type="radio"]') && !field.checked) {
    const groupIsChecked = $(
      `input[type="radio"][name="${field.name}"]:checked`
    ).length;

    return !groupIsChecked;
  }
  if (
    ($(field).is('input[type="checkbox"]') && !field.checked) ||
    field.value.length === 0
  ) {
    return true;
  }

  return false;
}

/**
 * Javascript Vanilla equivalent to Jquery $(element).trigger(eventName);
 * @param {HTMLElement} element event element
 * @param {string} eventName eventype
 */
function trigger(element, eventName) {
  if (
    typeof eventName === 'string' &&
    typeof element[eventName] === 'function'
  ) {
    element[eventName]();
  } else {
    const event =
      typeof eventName === 'string'
        ? new Event(eventName, { bubbles: true })
        : eventName;
    element.dispatchEvent(event);
  }
}

/**
 * Get the siblings from the element parameter
 * If optional selector parameter is used,
 *   only the siblings that match de selector will be returned
 * @param {HTMLElement} element
 * @param {string} [selector]
 * @returns {HTMLElement[]} Array of HTMLElements siblings of the element parameter
 */
function siblings(element, selector) {
  if (element.parentNode === null) {
    return [];
  }

  const children = selector
    ? element.parentNode.querySelectorAll(`:scope > ${selector}`)
    : element.parentNode.children;

  return Array.prototype.filter.call(children, (child) => child !== element);
}

module.exports = {
  addVisibilityHiddenBySelector,
  appendChildToHead,
  createPostFormAndSubmit,
  forEachElement,
  hideElementsBySelector,
  isFieldEmpty,
  isTag,
  loadAssetsFromObject,
  removeVisibilityHiddenBySelector,
  setMeta,
  showElementsBySelector,
  siblings,
  toggleElementsBySelector,
  trigger,
};
